import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl, CheckboxControl} from 'appShared/classes/controls';

import {RemovePlatformFrontendsControls} from 'appAssets/descriptors';
import {HttpStatusCodesEnum, PlatormFrontendModel, ServerResponse, ServerResponseData, SesService} from '@spa/api';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {switchMap} from 'rxjs/operators';
import {Helper} from 'appShared/classes';
import {PlatformFrontendFormErrorStatesEnum} from 'appEntries/panel/enums';
import {BaseMarketDataForm} from 'appShared/forms';

export class RemovePlatformFrontendForm extends BaseMarketDataForm {
    private readonly platforms: PlatormFrontendModel[];

    constructor(sesService: SesService, platforms: PlatormFrontendModel[]) {
        super(sesService);
        this.platforms = platforms;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});
        const platformControls = RemovePlatformFrontendsControls();

        for (const platform of this.platforms) {

            platformControls.push(
                new CheckboxControl({
                    name: `${platform.id}`,
                    value: platform.id,
                    placeholder: platform.name,
                    nonCapitalizedPlaceholder: true,
                    validators: [],
                    componentType: ComponentTypesEnum.Checkbox,
                    floatingLabelNever: true,
                    checked: false,
                    color: ColorCodesEnum.Primary,
                    expectBooleanValue: false
                })
            );
        }

        this.controls = platformControls.map((control: BaseControl) => {
            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }

    createRequest(): ServerResponse<boolean> {
        const ids: number[] = [];

        // tslint:disable-next-line:forin
        for (const property in this.formGroup.value) {
            const platformId = this.formGroup.value[property];
            if (platformId > 0) {
                ids.push(platformId);
            }
        }

        if (ids.length === 0) {
            return Helper.createSuccessResponseObservable<boolean>(true);
        }

        return this.sesService.deletePlatformFrontendByIdList(ids).pipe(
            switchMap((response: ServerResponseData<any>) => {

                if (response && response.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponseObservable<any>(
                        response,
                        PlatformFrontendFormErrorStatesEnum.DeletePlatformFrontendFailed
                    );
                }

                return Helper.createSuccessResponseObservable<boolean>(true);
            }));
    }
}
